<template lang="pug">
  section.section.features#features
    SectionTitle(:text="title", number="4", isContrast)
    .container
      .features__list
        .features__item.feature.feature--left
          .row
            .col-xs-12.col-sm-offset-1.col-sm-10.col-lg-offset-0.col-lg-6.col-xl-5
              .feture__text
                .row
                  .col-xs-12
                    .feature__title.title--left(v-fade, data-delay="1/3")
                      span.title__part Потому что
                      span.title__part натурально!
                  .col-xs-12.col-xl-offset-2.col-xl-10
                    .feature__description.text-small(v-fade, data-delay="3/3") Часто на бутылочных этикетках можно прочитать «произведено из высококачественных виноматериалов». Чтобы сразу развеять ваши сомнения, скажем — это настоящее вино, а не сухой порошок как многие ошибочно считают. Все дело в терминологии. У производителей вина принято всё вино, что не разлито по бутылкам, называть «виноматериалом». Попал виноматериал в бутылку — и вуаля — тут же превратился в вино. А «сухой виноматериал» - это вино с очень с низким содержанием сахара, то есть «сухое».
            .col-xs-12.col-sm-offset-1.col-sm-10.col-lg-offset-0.col-lg-6
              img.feature__image(src="~@/assets/naturals.jpg", alt="Потому что натурально!", v-fade, data-delay="2/3")
        .features__item.feature.feature--right
          .row
            .col-xs-12.col-sm-offset-1.col-sm-10.col-lg-offset-0.col-lg-6.col-xl-4
              .feture__text
                .row
                  .col-xs-12
                    .feature__title.title--right(v-fade, data-delay="1/3")
                      span.title__part Потому что
                      br
                      span.title__part вкусно!
                  .col-xs-12
                    .feature__description.text-small(v-fade, data-delay="3/3") Мы используем ароматизаторы не потому что хотим улучшить вкус вина, он прекрасен! Просто мы хотим еще больше праздника, еще больше вкусовых оттенков, больше ярких впечатлений. При этом заметим, все ароматизаторы — натуральные, то есть здесь нет никакой химии. 
                      | Поэтому не останавливайтесь в своих желаниях, наслаждайтесь Villa Blanca везде, где вам хочется праздника. 
            .col-xs-12.col-sm-offset-1.col-sm-10.col-lg-offset-0.col-lg-6.col-xl-offset-1.first-lg
              img.feature__image(src="~@/assets/tasty.jpg", alt="Потому что вкусно!", v-fade, data-delay="2/3")
        .features__item.feature.feature--left
          .row
            .col-xs-12.col-sm-offset-1.col-sm-10.col-lg-offset-0.col-lg-6.col-xl-5
              .feture__text
                .row
                  .col-xs-12
                    .feature__title.title--left(v-fade, data-delay="1/3")
                      span.title__part Потому что
                      span.title__part низкоалкогольно!
                  .col-xs-12.col-xl-offset-2.col-xl-10
                    .feature__description.text-small(v-fade, data-delay="3/3") Современный ритм жизни диктует свои условия. Иногда просто необходимо расслабиться, но при этом оставаться с ясной головой. Низкоалкогольные напитки — отличная возможность для этого. Благодаря низкой крепости, вы можете расслабиться, раскрепоститься и отлично отдохнуть.
            .col-xs-12.col-sm-offset-1.col-sm-10.col-lg-offset-0.col-lg-6
              img.feature__image(src="~@/assets/low-alcohol.jpg", alt="Потому что низкоалкогольно!", v-fade, data-delay="2/3")

</template>
<script>
import SectionTitle from "./SectionTitle.vue";

export default {
  name: "Features",
  components: {
    SectionTitle
  },
  data() {
    return {
      title: "Почему Villa Blanca?"
    };
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.feature {
  margin-top: 40px;

  @include from("lg") {
    margin-top: 85px;
  }

  &__title {
    font-family: $font-mojito;
    margin-bottom: 25px;
    font-size: 47px;
    line-height: 32px;

    @include from("sm") {
      font-size: 70px;
      line-height: 47px;
    }

    @include from("md") {
      margin-bottom: 37px;
    }
  }
  &__description {
    margin-bottom: 20px;

    @include from("lg") {
      margin-bottom: 0;
      margin-left: 18px;
    }
  }
  &__image {
    width: 100%;
  }

  .title {
    &__part {
      border: none;
      background: radial-gradient(
          83.08px at 45.88% 47.4%,
          #e0d17a 0%,
          #a88932 100%
        )
        bottom left / 10px 10px repeat-x;
      display: inline-block;
      padding: 0 68px 9px 10px;
    }

    @include from("sm") {
      &--left {
        .title__part {
          margin-left: 18px;

          &:last-of-type {
            margin-left: 80px;
          }
        }
      }

      &--right {
        .title__part {
          margin-left: -3px;

          &:last-of-type {
            margin-left: 17px;
          }
        }
      }
    }
  }
}
</style>